<template>
  <div class="meeting-base_wrapper">
    <div class="meeting_purposeOrIssue pb-1">
      {{ meetingInfo.purposeOrIssue }}
    </div>
    <div>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center">
              <img class="meeting-icon" :src="vipIcon" />
              <span>{{ meetingInfo.custName }}</span>
            </div>
            <div style="margin-left: 40px" class="d-flex align-items-center">
              <img class="meeting-icon" :src="shopIcon" />
              <span>{{ meetingInfo.expoInfoName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="d-flex justify-content-end">
            <SearchTabs
              v-model="tab"
              :options="searchTabOpts"
              @change="changeTab"
            ></SearchTabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="meeting_time mb-2">
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <img class="meeting-icon" :src="vipIcon" />
            <span>{{ meetingInfo.custName }}</span>
          </div>
          <div style="margin-left: 40px" class="d-flex align-items-center">
            <img class="meeting-icon" :src="shopIcon" />
            <span>{{ meetingInfo.expoInfoName }}</span>
          </div>
        </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
        <div class="d-flex justify-content-end">
          <SearchTabs
            v-model="tab"
            :options="searchTabOpts"
            @change="changeTab"
          ></SearchTabs>
        </div>
        </el-col>
      </el-row>

      <!-- <div class="meeting_tab">
    
    </div> -->
    <!-- <div>
        <img class="meeting-icon" :src="clockBlueIcon" />
        <div class="meeting_time-text">
          <span>{{ meetingInfo.meetingDate }}</span>
          <span>{{ meetingInfo.meetingWeek }}</span>
          <span>
            {{
              `${meetingInfo.meetingBeginTime} - ${meetingInfo.meetingEndTime}`
            }}
          </span>
          <span>{{ meetingInfo.v_meetingTimeZone }}</span>
        </div>
      </div> -->
    <!-- <div>
        <img class="meeting-icon" :src="clockRedIcon" />
        <div class="meeting_time-text">
          <span>{{ meetingInfo.meetingLocalDate }}</span>
          <span>{{ meetingInfo.meetingLocalWeek }}</span>
          <span>
            {{
              `${meetingInfo.meetingLocalBeginTime} - ${meetingInfo.meetingLocalEndTime}`
            }}
          </span>
          <span>{{ meetingInfo.meetingLocalTimeZone }}</span>
        </div>
      </div> -->
  </div>
  <!-- <div class="meeting-button">
      <div>
        <el-button size="small" plain>
          {{ $l('btn_meetingPreparation') || '会议准备' }}
        </el-button>
        <el-button size="small" plain>
          {{ $l('btn_meetingComments') || '会议纪要' }}
        </el-button>
        <el-button size="small" plain>
          {{ $l('btn_taskPlans') || '任务安排' }}
        </el-button>
        <el-button size="small" plain>
          {{ $l('btn_taskEnd') || '任务结束' }}
        </el-button>
      </div>
      <div class="meeting_attendance">
        <span class="mr-2">
          {{ $l('from_label_attendance') || '会议负责人' }}:
        </span>
        <span>{{ convertsArrayString(meetingInfo.attendanceNameList) }}</span>
      </div>
    </div> -->
</template>

<script>
const clockBlueIcon = require('../../icon/clock-blue.png')
const clockRedIcon = require('../../icon/clock-red.png')
const vipIcon = require('../../icon/vip.png')
const shopIcon = require('../../icon/shop.png')
import SearchTabs from '../search-tabs'

export default {
  props: {
    meetingInfo: { type: Object, default: () => {} },
    value: { type: String, default: 'MI' },
    searchTabOpts: { type: Array, default: () => [] },
  },
  components: { SearchTabs },
  data() {
    return {
      clockBlueIcon,
      clockRedIcon,
      vipIcon,
      shopIcon,
      SearchTabs,
      tab: 'MI',
    }
  },
  methods: {
    convertsArrayString(str) {
      if (!str) return ''
      const data = JSON.parse(str)
      return data.join(' / ')
    },
    changeTab(value) {
      this.$emit('update:value', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.meeting-base_wrapper {
  .meeting-icon {
    width: 24px;
    height: 24px;
  }
  .meeting_no {
    color: rgba(108, 108, 108, 1);
    font-size: 14px;
  }
  .meeting_purposeOrIssue {
    color: rgba(16, 16, 16, 1);
    font-size: 20px;
    font-weight: 600;
  }
  .meeting_tab {
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .meeting_time {
    width: 100%;
    align-content: center;
    font-size: 14px;
    line-height: 20px;
    color: rgba(79, 79, 79, 1);
    font-size: 14px;
    font-weight: 600;
    > div {
      display: flex;
      align-items: center;
      margin-right: 40px;
    }
    > div:last-child {
      margin-right: 0;
    }
    .meeting_time-text {
      margin-left: 8px;
    }
    .meeting-icon {
      width: 24px;
      height: 24px;
    }
  }
  // @media screen and (max-width: 1120px) {
  //   .meeting_time {
  //     display: block;
  //   }
  // }
  .meeting-button {
    display: flex;
    align-items: center;
    .el-button {
      border-radius: 4px !important;
    }
    .meeting_attendance {
      color: rgba(79, 79, 79, 1);
      font-size: 14px;
      margin-left: 40px;
    }
  }
}
.justify-content-end {
  justify-content: end;
}
@media only screen and (max-width: 767px) {
  .justify-content-end {
    justify-content: start !important;
  }
}
@media only screen and (min-width: 768px) {
  .justify-content-end {
    justify-content: start !important;
  }
}
@media only screen and (min-width: 1200px) {
  .justify-content-end {
    justify-content: end !important;
  }
}

@media only screen and (min-width: 992px) {
  .justify-content-end {
    justify-content: end !important;
  }
}
</style>
